import React, { useRef, useState, useEffect } from 'react';
import { Editor } from '@tinymce/tinymce-react';

const Textarea = ({ note, setGeneralNotes, setGeneralNotesDB, generalNotesDB, setNotes, value }) => {
    const editorRef = useRef(null);

    const [tinymceGeneralNotesValue, setGeneralNotesValue] = useState(generalNotesDB ?? '');
    const [tinymceNotesValue, setNotesValue] = useState(value ?? '');
    const apiKey = '3k7fdukowuzzp2t99etsarlujfrnrdhb0ju3wh8tvbeu0h8s';

    const tinymceConfig = {
        height: "200",
        menubar: false,
        plugins: [
            'advlist', 'lists', 'image', 'charmap', 'preview',
            'anchor', 'searchreplace', 'visualblocks', 'code', 'fullscreen',
            'insertdatetime', 'media', 'table', 'code', 'help', 'wordcount'
        ],
        toolbar: 'undo redo | blocks | ' +
            'bold italic forecolor | alignleft aligncenter ' +
            'alignright alignjustify | bullist numlist outdent indent | ' +
            'removeformat | help',
        content_style: 'body { font-family:Helvetica,Arial,sans-serif; font-size:14px }',
        skin: 'oxide-dark',
        content_css: "dark"
    }

    useEffect(() => {
        if (setGeneralNotesDB) {
            setGeneralNotesDB(tinymceGeneralNotesValue);
        }
        else if (setGeneralNotes) {
            setGeneralNotes(tinymceGeneralNotesValue);
        }
        else if (note !== 'general') {
            setNotes(tinymceNotesValue);
        }
        // eslint-disable-next-line
    }, [tinymceGeneralNotesValue, tinymceNotesValue]);

    if (setGeneralNotes || setGeneralNotesDB) {
        return (
            <Editor
                apiKey={apiKey}
                onInit={(evt, editor) => editorRef.current = editor}
                value={tinymceGeneralNotesValue}
                onEditorChange={(newValue) => setGeneralNotesValue(newValue)}
                init={tinymceConfig}
            />
        );
    } else if (note !== 'general') {
        return (
            <Editor
                apiKey={apiKey}
                onInit={(evt, editor) => editorRef.current = editor}
                value={tinymceNotesValue}
                onEditorChange={(newValue) => setNotesValue(newValue)}
                init={tinymceConfig}
            />
        );
    }
}
export default Textarea;